
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"169","height":"358","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"opacity":".11","d":"M168.5 357.5L1 65.74 134.929-196","stroke":"#111","stroke-miterlimit":"10"}})])
      }
    
      }
    